import React, { useState } from "react";
import moment from "moment";
import { TextField } from "@mui/material";
import Layout from "../../components/Layout/Layout";
import { useGlobalData } from "../../context/globalDataContxt";
import DynamicPager from "../../components/Pager/dynamicPager";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faNewspaper } from "@fortawesome/free-solid-svg-icons";
import Button from "../../shared/Button/Button";
import "./allNotesFeed.scss";

const NotesAll = ({ pageContext }) => {

  const { notesData, navbar, footerData } = pageContext;
  const { configPucc } = useGlobalData();

  const { title, notesFeedMetadata } = {
    title: "POSGRADOS UCC EN LOS MEDIOS",
    notesFeedMetadata: {
      pageTitle: "Notas Escuela de Posgrado UCC",
      pageDescription:
        "Notas Escuela de Posgrado UCC | Universidad Católica de Córdoba. Posgrado, Maestrias, Doctorados, Especialidades",
      pageKeywords:
        "Universidad Católica de Córdoba, UCC - Posgrado, Notas Escuela de Posgrado UCC",
    },
  };

  const itemsPerPage = 12;
  const [currentPage, setCurrentPage] = useState(1);

  // Estado para el filtro seleccionado
  const [filteredNotesAll, setFilteredNotesAll] = useState(notesData);
  const totalPages = Math.ceil(filteredNotesAll.length / itemsPerPage);

  // Función para manejar el cambio de filtro
  const handleFilterChange = (event) => {
    const selectedValue = event.target.value
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
    setCurrentPage(1); // Reinicia a la primera página tras el filtro

    if (selectedValue === "") {
      setFilteredNotesAll(notesData);
    } else {
      setFilteredNotesAll(
        notesData.filter((note) => {
          const titleValue = note.title
            .toLowerCase()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "");
          const mediumValues = note.note_mediums.map((medium) =>
            medium.name
              .toLowerCase()
              .normalize("NFD")
              .replace(/[\u0300-\u036f]/g, "")
          );
          return (
            titleValue.includes(selectedValue) ||
            mediumValues.some((medium) => medium.includes(selectedValue))
          );
        })
      );
    }
  };

  // Obtiene los elementos para la página actual
  const paginatedNotes = filteredNotesAll.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };
  console.log("Notas Escuela de Posgrado: ", notesData);
  return (
    <Layout
      screenData={navbar}
      pageMetadata={notesFeedMetadata}
      footerData={footerData}
    >
      <section className="all-notes-feed-container mb-3">
        <div className={`container my-5 all-notes-feed`}>
          <div className="px-2 d-flex align-items-center justify-content-between mb-4">
            <div className="col-12 col-md-6 px-0">
              <div className=" border-bottom">
                <div className="notes-title">
                  <FontAwesomeIcon icon={faNewspaper} className="me-2" />
                  {title}
                </div>
              </div>
            </div>
            <TextField
              id="standard-basic"
              label="Buscar por título o medio"
              variant="standard"
              onChange={handleFilterChange}
            />
          </div>
          <div className="row notes-container">
            {paginatedNotes < 1 ? (
              <h4 className="mt-5 col">
                No se encontraron notas con los titulos o autores buscados.
              </h4>
            ) : (
              paginatedNotes.map((note, index) => {
                return (
                  <div
                    className={`mb-4 col-12 col-md-6 col-lg-4`}
                    key={`noveltiesNodesId-` + index}
                  >
                    <div
                      className={`h-100 d-flex notes-card rounded shadow  overflow-hidden position-relative flex-column`}
                    >
                      <div
                        className={`notes-image`}
                        style={
                          note.thumbnail
                            ? { backgroundImage: `url(${note?.thumbnail.url})` }
                            : { backgroundImage: `url(${configPucc.noveltiesFeedConfig.noveltyImgDefaul?.url})`}
                        }
                        role="img"
                        alt={note.thumbnailName || ""}
                      ></div>
                      <div className=" flex-grow-1 p-4 d-flex flex-column notes-info">
                        <div className="notes-date">
                          <small>
                            {moment(note.date)
                              .locale("es")
                              .format("DD-MM-YYYY")}
                          </small>
                        </div>
                        <h5 className="notes-title">
                          {note.title}
                        </h5>
                        <div className="noticies-markdown">
                          <p>{note?.summary ? note.summary : null}</p>
                        </div>
                        <Button
                          classButton={`text-left px-4 mb-0 rounded-0`}
                          button={{
                            url: `ucc.edu.ar/notas/${note.slug}`,
                            label: "LEER NOTA",
                          }}
                          customButton={{
                            variant: note.destacado
                              ? "secondary"
                              : "secondary_outline",
                            size: "",
                            shape: "pill",
                          }}
                          classContainer="d-flex mt-auto"
                        />
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
          <DynamicPager
            currentPage={currentPage}
            totalPages={totalPages}
            itemsPerPage={itemsPerPage}
            onPageChange={handlePageChange}
          />
        </div>
      </section>
    </Layout>
  );
};

export default NotesAll;
